import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db, usersCollection, createUserWithEmailAndPassword, sendEmailVerification, setDoc, doc } from '../firebase/config';
import CustomCursor from '../components/CustomCursor';
import './SignupPage.css';

const SignupPage = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSignup = async (e) => {
    e.preventDefault();
    
    if (!name || !email || !password) {
      setError('⛧ All fields are required ⛧');
      return;
    }
    if (password !== confirmPassword) {
      setError('⛧ Passwords do not match ⛧');
      return;
    }
    if (password.length < 6) {
      setError('⛧ Password must be at least 6 characters ⛧');
      return;
    }
    
    setError('');
    setSuccess('');
    setLoading(true);
    
    try {
      // Create user in Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      // Send email verification
      await sendEmailVerification(user);
      
      // Save user data to Firestore - ALL CHAPTERS LOCKED BY DEFAULT
      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        email: email,
        name: name,
        role: "user",
        unlockedChapters: [], // NO chapters unlocked by default
        createdAt: new Date().toISOString()
      });
      
      setSuccess('✓ Verification email sent! Please check your inbox and verify your email before logging in.');
      
      setTimeout(() => {
        navigate('/login');
      }, 4000);
    } catch (err) {
      let message = '⛧ Initiation failed ⛧';
      if (err.code === 'auth/email-already-in-use') message = '⛧ Email already registered ⛧';
      if (err.code === 'auth/invalid-email') message = '⛧ Invalid email address ⛧';
      if (err.code === 'auth/weak-password') message = '⛧ Password too weak ⛧';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-page">
      <CustomCursor />
      <div className="auth-card">
        <div className="glitch-text">INITIATION</div>
        <div className="auth-title">CREATE ACCESS PROTOCOL</div>
        <div className="auth-sub">JOIN THE ARCHIVE</div>

        <form onSubmit={handleSignup}>
          <div className="input-group">
            <div className="input-label">FULL NAME</div>
            <input 
              type="text" 
              className="auth-input" 
              placeholder="Enter your full name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="input-group">
            <div className="input-label">EMAIL ADDRESS</div>
            <input 
              type="email" 
              className="auth-input" 
              placeholder="identity@skullture.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-group">
            <div className="input-label">PASSWORD</div>
            <input 
              type="password" 
              className="auth-input" 
              placeholder="Create a strong password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="input-group">
            <div className="input-label">CONFIRM PASSWORD</div>
            <input 
              type="password" 
              className="auth-input" 
              placeholder="Confirm your password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <div className="auth-error">{error}</div>
          <div className="success-msg">{success}</div>

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? <span className="spinner"></span> : '⟡ INITIATE ⟡'}
          </button>
        </form>
        
        <div className="auth-link" onClick={() => navigate('/entry')}>← BACK TO ENTRY GATE</div>
        <div className="auth-link" onClick={() => navigate('/login')}>← ALREADY HAVE ACCOUNT? LOGIN →</div>
      </div>
    </div>
  );
};

export default SignupPage;